module.exports = __webpack_public_path__ + "img/Frame4299.f2268983.png";